<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Transaction Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="tr_date_from"/> ~ <CustomDatePicker v-model="tr_date_to"/></span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<div style="height: 630px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
						<thead>
							<tr>
								<th style="text-align:center;width:120px;">Transaction No</th>
								<th style="text-align:center;width:180px;">Transaction Date</th>
								<th style="text-align:center;">Memo</th>
								<th style="text-align:center;width:120px;">User ID</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="t in transactions" v-bind:key="t.it_no" v-bind:class="{ on: t.it_no == selectedTransaction.it_no }" @click="selectRow(t)">
								<td>{{ t.it_dn }}</td>
								<td>{{ t.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td>{{ t.memo }}</td>
								<td>{{ t.crt_user }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="mode != 'add'" href="javascript:;" class="gray_bt" @click="addTransaction()">Add</a>
				</div>
			</div>

			<div class="right_small3_tbl">
				<h4 class="inner_h5">Transaction Detail</h4>
				<div style="height: 630px; overflow-y: auto; overflow-x: hidden;">
					<div class="list_top_box">
						<div class="left_option">
							<span class="int_type full_int">
								<input type="text" v-model.trim="memo" :readonly="mode == 'detail'" autocomplete="off" placeholder="Memo" />
							</span>
						</div>
						<div class="left_option" v-show="mode == 'add'" style="padding-top:5px;">
							<span class="int_type full_int">
								<AC ref="ac" :source="selectACItems" @selected="selectACItem" results-display="code_name" placeholder="Item / Name or ID"> </AC>
							</span>
						</div>
					</div>

					<table v-if="mode == 'add'" class="list_tbl tbl_pointer" border="0">
						<thead>
							<tr>
								<th style="text-align:center;width:160px;">Item Code</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:40px;">WH1</th>
								<th style="text-align:center;width:60px;">New</th>
								<th style="text-align:center;width:40px;">WH2</th>
								<th style="text-align:center;width:60px;">New</th>
								<th style="text-align:center;width:40px;">N/D</th>
								<th style="text-align:center;width:60px;">New</th>
								<!-- <th style="text-align:center;width:80px;">Shipment No</th>
								<th style="text-align:center;width:70px;">Exp Date</th>
								<th style="text-align:center;width:70px;">Init Qty</th>
								<th style="text-align:center;width:70px;">Cur Qty</th>
								<th style="text-align:center;width:70px;">Location</th>								 -->
								<th style="text-align:center;width:40px;">Del</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, index) in items" v-bind:key="item.item_id">
								<td>{{ item.item_code }}</td>
								<td>{{ item.name }}</td>
								<td class="al_right">{{ item.WH1 }}</td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.WH1_new" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" /></td>
								<td class="al_right">{{ item.WH2 }}</td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.WH2_new" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" /></td>
								<td class="al_right">{{ item.WH_NULL }}</td>
								<td class="al_right"><currency-input type="text" v-model.trim="item.WH_NULL_new" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" /></td>
								<!-- <td class="al_left"><CustomDatePicker v-model="lot.exp_date" /></td>
								<td><currency-input type="text" v-model="lot.initial_quantity" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td><currency-input type="text" v-model="lot.on_hand" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td>
									<select v-model="lot.location_code" class="tbl_select">
										<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
									</select>
								</td>
								<td><input type="text" v-model="lot.bin" class="tbl_int" @focus="$event.target.select()" /></td> -->
								<td>
									<template v-if="!(selectedTransaction.it_no > 0)">
										<a href="javascript:void(0);" class="gray_bt2" @click="delItem(index)">Del</a>
									</template>
								</td>
							</tr>
						</tbody>
					</table>

					<table v-if="mode == 'detail'" class="list_tbl tbl_pointer" v-columns-resizable border="0">
						<thead>
							<tr>
								<th style="text-align:center;width:160px;">Item Code</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:120px;">Location</th>
								<th style="text-align:center;width:55px;">Before</th>
								<th style="text-align:center;width:40px;">After</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in histories" v-bind:key="item.inventory_no">
								<td>{{ item.item_code }}</td>
								<td>{{ item.item_name }}</td>
								<td>{{ item.location_code == 'WH_NULL' ? 'N/D' : item.location_code }}</td>
								<td class="al_right">{{ item.before_quantity }}</td>
								<td class="al_right">{{ item.after_quantity }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="view_bottom_bt">
					<a v-if="modifiable && mode == 'add'" href="javascript:;" id="save" type="button" class="search_bt" @click="save()">Save</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//import _ from 'lodash';
// import { apiIndex, apiSelectItemList } from '@/api/item/master.js';
import { apiSelectItem } from '@/api/item/master.js';
import { apiSelectInventoryTransactionList, apiSelectInventoryHistoryList } from '@/api/item/inventory.js';
import Paging from '@/components/common/Paging';
import AC from '@/components/common/AC';
// import PageSizeSelect from '@/components/common/PageSizeSelect';
// import CodeSelect from '@/components/common/CodeSelect';
// import ItemClassSelect from '@/components/common/ItemClassSelect';
import { apiAdjustBatch } from '@/api/item/inventory.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { daysAgo, today } from '@/utils/date';

import CustomDatePicker from '@/components/common/CustomDatePicker.vue';

export default {
	data: function() {
		return {
			tr_date_from: daysAgo(6),
			tr_date_to: today(),

			uri: null,

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			transactions: [],
			selectedTransaction: {},

			items: [],
			histories: [],

			mode: null,
			memo: null,
			// item_code: null,
			// item_name: null,

			item: {},
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		// PageSizeSelect,
		// CodeSelect,
		// ItemClassSelect,
		AC,
		CustomDatePicker,
	},
	methods: {
		async save() {
			var item_data = [];

			this.items.forEach(function(item) {
				if (item.WH1 != item.WH1_new || item.WH2 != item.WH2_new || item.WH_NULL != item.WH_NULL_new) {
					var param_item = {
						item_id: item.item_id,
						wh1_before_quantity: item.WH1,
						wh1_after_quantity: item.WH1_new,
						wh2_before_quantity: item.WH2,
						wh2_after_quantity: item.WH2_new,
						wh_null_before_quantity: item.WH_NULL,
						wh_null_after_quantity: item.WH_NULL_new,
					};

					if (!param_item.wh1_before_quantity) param_item.wh1_before_quantity = 0;
					if (!param_item.wh1_after_quantity) param_item.wh1_after_quantity = 0;

					if (!param_item.wh2_before_quantity) param_item.wh2_before_quantity = 0;
					if (!param_item.wh2_after_quantity) param_item.wh2_after_quantity = 0;

					if (!param_item.wh_null_before_quantity) param_item.wh_null_before_quantity = 0;
					if (!param_item.wh_null_after_quantity) param_item.wh_null_after_quantity = 0;

					item_data.push(param_item);
				}
			});

			if (item_data.length == 0) {
				this.$toast.error('Nothing to adjust');
				return;
			}

			var param = {
				adjust_reason: 'adjust',
				items: item_data,
				memo: this.memo,
			};

			if (this.user.company_id == 'jc') {
				param.each_warehouse = true;
				param.create_transaction = true;
			}

			//console.log(param);
			// const dummy = true;
			// if (dummy) return;

			const { data } = await apiAdjustBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//this.selectItems();
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		delItem(index) {
			this.items.splice(index, 1);
		},
		search() {
			this.page_no = 1;
			this.selectTransactions();
		},
		reset() {
			this.tr_date_from = daysAgo(6);
			this.tr_date_to = today();

			this.search();
		},
		async addTransaction() {
			this.mode = 'add';
			this.memo = null;
			this.selectedTransaction = {};
			this.items = [];
		},
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=true&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			//console.log(i.selectedObject);
			// this.item_code = i.selectedObject.item_code;
			// this.item_name = i.selectedObject.name;
			this.addItem(i.selectedObject.item_id);
			//this.loadItem(i.selectedObject.item_id);
		},
		async addItem(item_id) {
			if (this.items.filter(i => i.item_id == item_id).length > 0) {
				this.$toast.error('Duplicate');
				return;
			}

			const { data } = await apiSelectItem({ item_id: item_id });
			let item = data.item;

			item.WH1 = null;
			item.WH2 = null;
			item.WH_NULL = null;
			if (item.wh_on_hand_str) {
				const wh_on_hands = item.wh_on_hand_str.split('||');
				wh_on_hands.forEach(woh => {
					const ohs = woh.split('|');

					if (ohs.length == 2) {
						if (ohs[0] == 'WH1') {
							item.WH1 = Number(ohs[1]);
							item.WH1_new = Number(ohs[1]);
						} else if (ohs[0] == 'WH2') {
							item.WH2 = Number(ohs[1]);
							item.WH2_new = Number(ohs[1]);
						} else if (ohs[0] == 'WH_NULL') {
							item.WH_NULL = Number(ohs[1]);
							item.WH_NULL_new = Number(ohs[1]);
						}
					}
				});
			}
			//console.log(data);
			//this.items.push(_.cloneDeep(data.item));
			this.items.push(item);
		},
		async loadItem(item_id) {
			//console.log(item_id);
			const { data } = await apiSelectItem({ item_id: item_id });
			//console.log(data);
			this.item = data.item;

			this.item.WH1 = null;
			this.item.WH2 = null;
			this.item.WH_NULL = null;
			if (this.item.wh_on_hand_str) {
				const wh_on_hands = this.item.wh_on_hand_str.split('||');
				wh_on_hands.forEach(woh => {
					const ohs = woh.split('|');

					if (ohs.length == 2) {
						if (ohs[0] == 'WH1') {
							this.item.WH1 = Number(ohs[1]);
							this.item.WH1_new = Number(ohs[1]);
						} else if (ohs[0] == 'WH2') {
							this.item.WH2 = Number(ohs[1]);
							this.item.WH2_new = Number(ohs[1]);
						} else if (ohs[0] == 'WH_NULL') {
							this.item.WH_NULL = Number(ohs[1]);
							this.item.WH_NULL_new = Number(ohs[1]);
						}
					}
				});
			}
		},
		async selectTransactions(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.selectedTransaction = {};
			this.mode = 'detail';
			this.memo = null;
			this.items = [];

			var param = {
				tr_date_from: this.tr_date_from,
				tr_date_to: this.tr_date_to,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
			};

			const { data } = await apiSelectInventoryTransactionList(param);
			//console.log(data);
			this.transactions = data.inventoryTransactionList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/item/inventory_transaction?dummy=1';
			if (this.tr_date_from) uri += '&tr_date_from=' + this.tr_date_from;
			if (this.tr_date_to) uri += '&tr_date_to=' + this.tr_date_to;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPage(pageNo) {
			this.selectTransactions(pageNo);
		},
		async selectRow(tr) {
			this.selectedTransaction = tr;
			this.mode = 'detail';
			this.memo = this.selectedTransaction.memo;

			//console.log(this.selectedTransaction);

			const { data } = await apiSelectInventoryHistoryList({
				paging_yn: 'N',
				it_no: this.selectedTransaction.it_no,
			});

			this.histories = data.inventoryHistoryList;
			//console.log(this.histories);
		},
		async index() {
			//const { data } = await apiIndex();
		},
		async init() {
			await this.index();
			//if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.tr_date_from) this.tr_date_from = this.$route.query.tr_date_from;
			if (this.$route.query.tr_date_to) this.tr_date_to = this.$route.query.tr_date_to;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;

			//await this.selectItems(this.$route.query.page_no);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_transaction');
		this.$store.commit('setSubTitle', 'Item -> Inventory Transaction');

		this.init();
		this.selectTransactions();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
